import React from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BuildingIcon from 'assets/myAppointments/appointmentsList/building.svg';
import ByIcon from 'assets/myAppointments/appointmentsList/by.svg';
import DateIcon from 'assets/myAppointments/appointmentsList/date.svg';
import MapIcon from 'assets/myAppointments/appointmentsList/map.svg';
import PackageIcon from 'assets/myAppointments/appointmentsList/package.svg';
import PhoneIcon from 'assets/myAppointments/appointmentsList/phone.svg';
import PlayIcons from 'assets/myAppointments/appointmentsList/play.svg';
import ChevronRight from 'assets/myAppointments/appointmentsList/right.svg';
import TimeIcon from 'assets/myAppointments/appointmentsList/time.svg';
import UserAvatarIcon from 'assets/myAppointments/appointmentsList/user.svg';
import { CustomTooltip } from 'common-ui/table/CustomTooltip';
import { LoadContainer, LoadingIcon } from 'common-ui/table/Table.styles';
import loadIcon from 'common-ui/table/loading.svg';
import { selectData, selectLoading } from 'features/myAppointments/MyAppointmentsSlice';
import EmptyView from 'pages/components/emptyView/EmptyView';
import { formatDateTime } from 'utils/dateUtils';

import { STATUS_CONFIG } from '../MyAppointmentsConstants';
import {
  ActionButton,
  AvatarWrapper,
  ByText,
  Card,
  CardHeader,
  CompanyTag,
  Content,
  EmptyContainer,
  Icon,
  InfoGrid,
  InfoItem,
  LocationText,
  NameBlock,
  StatusTag,
  UserInfo,
  UserName,
} from './AppointmentsList.styles';

const AppointmentsList = () => {
  const navigate = useNavigate();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const handleCardClick = (uuid) => {
    navigate(`/my-single-appointments/${uuid}`);
  };
  if (loading)
    return (
      <LoadContainer>
        <LoadingIcon src={loadIcon} alt="Loading..." />
      </LoadContainer>
    );

  if (!data.length)
    return (
      <EmptyContainer>
        <EmptyView description="no data founded" />
      </EmptyContainer>
    );

  return (
    <Content>
      {data.map((item) => {
        const statusKey = item.urgencyLevel.toLowerCase();
        const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.upcoming;

        return (
          <Card
            key={item.id}
            $gradient={config.gradient}
            $borderColor={config.borderColor}
            onClick={() => handleCardClick(item.uuid)}
          >
            <CardHeader>
              <UserInfo>
                <AvatarWrapper>
                  <Icon
                    $src={item.leadType === 'B2B' ? BuildingIcon : UserAvatarIcon}
                    $color={config.color}
                  />
                </AvatarWrapper>
                <NameBlock>
                  <div className="name-row">
                    <UserName>{item.customerName || item.leadName}</UserName>
                    {item.company && <CompanyTag>{item.company}</CompanyTag>}
                    <div className="status-container">
                      <StatusTag $bg={'#2B7FFF1A'} $color={'#2D6CDF'}>
                        <span>{item.service}</span>
                      </StatusTag>
                      <StatusTag $bg={config.bg} $color={config.color}>
                        <Icon $src={config.icon} $color={config.color} />
                        <span>{config.label}</span>
                      </StatusTag>
                      <Icon className="chevron" $src={ChevronRight} $color="#6c757d" />
                    </div>
                  </div>
                  <InfoGrid>
                    <InfoItem>
                      <Icon $src={PhoneIcon} $color="#6c757d" />{' '}
                      <span>{item.communicationMethod?.phoneCall}</span>
                    </InfoItem>
                    <InfoItem>
                      <Icon $src={MapIcon} $color="#6c757d" />
                      <CustomTooltip title={item.location || ''} placement="top" arrow>
                        <LocationText>{item.location}</LocationText>
                      </CustomTooltip>
                    </InfoItem>
                    <div className="info-grid">
                      <InfoItem>
                        <Icon $src={DateIcon} $color="#212529" />
                        <span className="color-date">{formatDateTime(item.date)}</span>
                      </InfoItem>
                      <InfoItem>
                        <Icon $src={TimeIcon} $color="#6c757d" />
                        <span>
                          {item.time} ({item.duration})
                        </span>
                      </InfoItem>
                    </div>
                  </InfoGrid>
                  {item.currentOffer || (item.leadOffers && item.leadOffers.length > 0) ? (
                    <InfoItem>
                      <Icon $src={PackageIcon} $color="#6c757d" />{' '}
                      <span>
                        {item.currentOffer
                          ? item.currentOffer
                          : item.leadOffers.map((o) => o.name).join(', ')}
                      </span>
                    </InfoItem>
                  ) : (
                    <InfoItem>
                      <Icon $src={PackageIcon} $color="#6c757d" /> -
                    </InfoItem>
                  )}
                  <ByText>
                    <Icon $src={ByIcon} $color="#6c757d" />
                    <span>
                      By: {item.createdBy?.firstName} {item.createdBy?.lastName}
                    </span>
                  </ByText>
                </NameBlock>
              </UserInfo>
            </CardHeader>
            {console.log('statusKey', item.status) || null}
            {statusKey !== 'refused' && statusKey !== 'completed' && (
              <ActionButton>
                <Icon $src={PlayIcons} $color="#2d6cdf" />
                {item.status !== 'In Progress' ? 'Start Work' : 'In Progress'}
              </ActionButton>
            )}
          </Card>
        );
      })}
    </Content>
  );
};

export default AppointmentsList;
